import React from "react";
import styled from "styled-components/macro";
// import MetaTags from "react-meta-tags";

// Styling
import { TextContainer } from "styling/GlobalStyling";

// Components
import { PageHeading } from "../components/PageHeading";

import { servicesData } from "../services-data";
import { Service } from "../components/Service";

// ABOUT PAGE --------------------------------------
export const Services = () => {
  return (
    <>
      {/* <MetaTags>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>We Exist - Våra tjänster</title>
        <meta
          name="description"
          content="Här hittar du alla våra tjänster. Alltifrån rekrytering, föreläsningar inom jämställdhet, skapa 
          jobbannonser, samt ledarskapsutbildning."
        />
        <meta property="og:title" content="We Exist - Våra tjänster" />
        <meta
          property="og:description"
          content="Här hittar du alla våra tjänster. Alltifrån rekrytering, föreläsningar inom jämställdhet, skapa 
          jobbannonser samt ledarskapsutbildning."
        />
        <meta property="og:image" content="service-images/rekrytering.jpg" />
      </MetaTags> */}

      <PageHeading title="Våra tjänster" />
      <TextContainer>
        <p>
          Vad härligt att du har hittat hit! Det innebär förhoppningsvis att 
          ditt företag är medvetna om värdet av jämställdhet eller vill starta 
          den resan tillsammans med oss. Oberoende undersökningar visar att 
          företag som medvetet jobbar med jämställdhet är mer konkurrenskraftiga, 
          lönsamma, innovativa och har en högre trivsel. Vi på We Exist vet hur man 
          attraherar, rekryterar samt behåller kvinnliga medarbetare så låt oss 
          tillsammans se till att ni blir en arbetsplats där kvinnor trivs och 
          vill stanna. 
          Vi har ett av Sveriges största nätverk av kvinnor inom 
          Tech och IT och matchar dem gärna med ert företag.
          <br />
          <br />
          <ButtonStyling>
            <a href="mailto:hello@weexist.se">
              <Button type="button"
              text="Jag vill veta mer">
                  Jag vill veta mer
              </Button>
            </a>
          </ButtonStyling>
        </p>
      </TextContainer>

      <ServicesWrapper>
        {servicesData.map((data) => (
          <Service key={data.id} {...data} />
        ))}
      </ServicesWrapper>
    </>
  );
};

const ServicesWrapper = styled.section`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding-bottom: 50px;
`;

const ButtonStyling = styled.div`
  display: flex;
  justify-content: center;
`;

const Button = styled.button`
  padding: 10px 50px;
  margin: 10px;
  border-radius: 5px;
  border: none;
  background: #f07666;
  color: #fff;
  font-family: "Poppins", sans-serif;
  font-weight: bold;
  font-size: 18px;
  transition: all 0.3s;
  :hover {
    background-color: #ff9767;
    cursor: pointer;
  }
`;
